export default "__VITE_ASSET__cI4nOkot__";